// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"eb97a0a5","88":"3370ebe5","296":"9647a187","487":"5807db87","695":"447fd06a","770":"97be7464","846":"c569367c","871":"7e6e26a3","920":"3e2356c8"}[chunkId] + ".chunk.js";
};